import { useNavigate } from 'react-router';

import success from '../../../assets/images/successIcon.svg';
import { closePopup } from '../../../store/slices/popupSlice';
import { useAppDispatch } from '../../../store/store';
import RedButton from '../../ui/buttons/redButton/RedButton';
import styles from './styles/styles.module.css';

function SignAgreePopup() {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const handleClosePopup = () => {
    dispatch(closePopup());
  };

  return (
    <div className={styles.successPopupWrapper}>
      <button
        className={styles.closePopupButton}
        onClick={handleClosePopup}
        aria-label="Закрыть"
      />
      <div className={styles.successTextWrapper}>
        <img src={success} alt="иконка успех" />
        <h3 className={styles.successSubTitle}>
          Для оформления вашего заказа нам потребуется заключить договор.
        </h3>
        <p className={styles.successText}>
          Пожалуйста, свяжитесь с менеджером — он поможет со всеми формальностями и
          ответит на любые вопросы.
        </p>
      </div>
      <RedButton
        text="Связаться с менеджером"
        onClick={() => {
          navigate('/contacts');
          dispatch(closePopup());
        }}
        width={308}
        height={54}
      />
    </div>
  );
}

export default SignAgreePopup;
